// load scss
import './Main.scss';

import '../JavaScript/scrollstart';
import '../JavaScript/main';
